import { Component, inject, Input, OnInit } from '@angular/core';
import { Apartment } from '@modules/universal-billing/apartments/apartments.interface';
import { ApartmentStatusDirective } from '@common/directive/apartment-status.directive';
import { ResourceByIdPipe } from '@shared/pipes/resource-by-id.pipe';
import { TranslatePipe } from '@ngx-translate/core';
import { RouterLink } from '@angular/router';
import { Resources } from '@app/resources';
import { ApartmentUnitStatusDirective } from '@common/directive/apartment-unit-status.directive';
import { ApiService } from '@shared/services/api.service';
import { BaseLoadComponent } from '@shared/components/classes/base-load.component';
import { Observable } from 'rxjs';
import { DatePipe, NgIf } from '@angular/common';
import {
  NgbAccordionBody,
  NgbAccordionButton,
  NgbAccordionCollapse,
  NgbAccordionDirective, NgbAccordionHeader, NgbAccordionItem
} from '@ng-bootstrap/ng-bootstrap';
import { PropertyStatusDirective } from '@common/directive/property-status.directive';

@Component({
  selector: 'app-property-apartment-card',
  standalone: true,
  imports: [
    ApartmentStatusDirective,
    ResourceByIdPipe,
    TranslatePipe,
    RouterLink,
    ApartmentUnitStatusDirective,
    DatePipe,
    NgIf,
    NgbAccordionBody,
    NgbAccordionButton,
    NgbAccordionCollapse,
    NgbAccordionDirective,
    NgbAccordionHeader,
    NgbAccordionItem,
    PropertyStatusDirective
  ],
  templateUrl: './property-apartment-card.component.html',
  styleUrl: './property-apartment-card.component.scss'
})
export class PropertyApartmentCardComponent extends BaseLoadComponent<any>{
  @Input() buildingId: number;
  @Input() item:any;
  protected readonly Resources = Resources;
  apartments:Apartment[];
  api=inject(ApiService)

  getData(): Observable<any> {
    return this.api.get('v1/apartments',{buildingId:this.buildingId});
  }
}
